<template>
    <div>
        <div class="layout-wrapper">
            <Header />
            <Menubar />
            <slot></slot>
        </div>
        <Footer />
    </div>
</template>

<script>
import Api from "@/Api";
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import Menubar from "./Menubar.vue";

export default {
    name: "Layout",
    components: {
        Header,
        Footer,
        Menubar
    },
    created() {
        Api()
            .get("auth/get-conference-text")
            .then(res => {
                this.$store.dispatch("setConferenceTextData", res.data);
            })
            .catch(err => {
                console.log(err);
            });
    }
};
</script>

<style lang="scss">
@font-face {
    font-family: Roboto;
    font-style: italic;
    font-weight: 300;
    src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
        url(https://fonts.gstatic.com/s/roboto/v18/KFOjCnqEu92Fr1Mu51TjASc0CsE.ttf)
            format("truetype");
}
@font-face {
    font-family: Roboto;
    font-style: italic;
    font-weight: 400;
    src: local("Roboto Italic"), local("Roboto-Italic"),
        url(https://fonts.gstatic.com/s/roboto/v18/KFOkCnqEu92Fr1Mu51xGIzc.ttf)
            format("truetype");
}
@font-face {
    font-family: Roboto;
    font-style: italic;
    font-weight: 500;
    src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
        url(https://fonts.gstatic.com/s/roboto/v18/KFOjCnqEu92Fr1Mu51S7ACc0CsE.ttf)
            format("truetype");
}
@font-face {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    src: local("Roboto Light"), local("Roboto-Light"),
        url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmSU5fChc9.ttf)
            format("truetype");
}
@font-face {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    src: local("Roboto"), local("Roboto-Regular"),
        url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu7GxP.ttf)
            format("truetype");
}
@font-face {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    src: local("Roboto Medium"), local("Roboto-Medium"),
        url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmEU9fChc9.ttf)
            format("truetype");
}
@font-face {
    font-family: "PT Sans Caption";
    font-style: normal;
    font-weight: 400;
    src: local("PT Sans Caption"), local("PTSans-Caption"),
        url(https://fonts.gstatic.com/s/ptsanscaption/v10/0FlMVP6Hrxmt7-fsUFhlFXNIlpcaeg_0.ttf)
            format("truetype");
}
@font-face {
    font-family: "PT Sans Caption";
    font-style: normal;
    font-weight: 700;
    src: local("PT Sans Caption Bold"), local("PTSans-CaptionBold"),
        url(https://fonts.gstatic.com/s/ptsanscaption/v10/0FlJVP6Hrxmt7-fsUFhlFXNIlpcSwSrkTA-q.ttf)
            format("truetype");
}

.layout-wrapper {
    @import "../../../public/assets/css/style";

    legend {
        font-size: 22px;
        font-weight: bold;
    }
    .text_underline {
        text-decoration: underline;
        color: #3498db;
    }
}
</style>
